<app-lp-template>
    <div class="px-3 pb-3 pt-2">
        <h2 class="text-center">Grazie della tua registrazione</h2>
        <h4 class="text-center">Per accedere devi aspettare la nostra conferma di iscrizione, riceverai una mail appena ti avremo confermato.</h4>
    </div>
</app-lp-template>